import { API, API_POST } from "../../../Config";


export const handleAddWorkout = (payload) => {
  const f = new FormData();
  
  f.append("title", payload.title);
  f.append("description", payload.description);
  f.append("banner_img", payload.image);
  f.append("video", payload.video);
  

  return API_POST(API.AddWorkout, f);
};
